import FormReport from "../../../../../components/pages/FormReport";
import { useFetch } from '../../../../../hooks/useFetch';

export default () => {
    return (
        <FormReport
            title={'Document PJT'}
            repType={'daily'}
            repUrl={'document_pjt'}
            url={"/api/v1/import_verify"}
            FetchComponent={useFetch}
        />
    )
}